/**
 * AOS (Animate on Scroll) Library - JavaScript Only
 * Loaded conditionally via ACF theme options
 */

import AOS from 'aos/dist/aos.js';

// Make available globally
window.AOS = AOS;

// Initialize AOS when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  if (typeof AOS !== 'undefined') {
    AOS.init({
      duration: 500, // values from 0 to 3000, with step 50ms
      offset: 0, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      easing: 'ease', // default easing for AOS animations
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: 'bottom-bottom', // defines which position of the element regarding to window should trigger the animation
      once: true, // whether animation should happen only once - while scrolling down
      startEvent: 'DOMContentLoaded',
      disable() {
        // Disable AOS on very small screens or hidden containers
        return window.innerWidth < 768;
      }
    });
  }

  setTimeout(() => {
    AOS.refresh();
  }, 1000);
});
